import id from './id';
import reset from './reset';

// TODO: Попытаться разбить на составные части аля belongsTo для инъекций
export default {
    mixins: [
        id,
        reset,
    ],
    inject: {
        $form: {
            default: null,
        },
        $field: {
            default: null,
        },
        $feedback: {
            default: null,
        },
    },
    props: {
        name: {
            type: String,
        },
        // TODO: Подумать над свойством silence
    },
    // TODO: Watch свойство, делающее objectAssign даты, при смене value (Подумать над тем, как делать $emit событий в таком случае).
    computed: {
        isInput() {
            return true;
        },
        isIgnored() {
            return false;
        },
        key() {
            return this.name ? this.name.split('[').join('.').split(']').join('').replace(/\.$/, '') : null;
        },
        feedback() {
            return this.$parent && !this.$parent.isInput && this.$form && this.key ? this.$form.getFeedback(this.key) : [];
        },
    },
    created() {
        if (this.$form) {
            this.$form.addInput(this);
            this.$form.$on('reset', this.resetData);
        }
        if (this.$field) this.$field.setInput(this);
        if (this.$feedback) this.$feedback.addInput(this);
        this.$on('change', this.clearFeedback);
    },
    beforeDestroy() {
        if (this.$form) this.$form.$off('reset', this.resetData);
        this.$off('change', this.clearFeedback);
    },
    methods: {
        clearFeedback() {
            if (this.$form && this.key) this.$form.clearFeedback(this.key);
        },
    },
}